import React from 'react';

const brands = [
  { name: 'Microsoft', slug: 'microsoft' },
  { name: 'Google', slug: 'google' },
  { name: 'Apple', slug: 'apple' },
  { name: 'Meta', slug: 'meta' },
  { name: 'OpenAI', slug: 'openai' },
  { name: 'PayPal', slug: 'paypal' },
  { name: 'DigitalOcean', slug: 'digitalocean' },
  { name: 'Shopify', slug: 'shopify' },
];

export const LogoMarquee = () => (
  <div className="logo-strip" data-testid="customer-logos">
    <span className="mono-label is-muted logo-strip-label">Trusted by security teams at</span>
    <div className="logo-strip-viewport">
      <div className="logo-strip-track">
        {[0, 1].map((dup) => (
          <React.Fragment key={dup}>
            {brands.map((b) => (
              <div className="logo-item" key={`${dup}-${b.slug}`} title={b.name}>
                <img
                  src={`${process.env.PUBLIC_URL}/logos/${b.slug}.svg`}
                  alt={b.name}
                />
                <span>{b.name}</span>
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  </div>
);
